<template>
  <Reference
    :id="value && value.id"
    :value="value"
    :label="label"
    placeholder="Введіть найменування або артикул сервісу"
    :items.sync="items"
    :total-items="totalItems"
    component-name="Service"
    data-test="service-select"
    @input="$emit('input', $event)"
    @getItems="getItems"
  />
</template>

<script>
import * as servicesApi from "@/backend/servicesApi.js";
import Reference from "@/components/Reference";

export default {
  components: {
    Reference,
  },
  props: {
    label: {
      type: String,
      default: "Сервіси",
    },
    value: {
      type: Object,
    }
  },
  data: () => ({
    items: [],
    totalItems: 0,
  }),
  methods: {
    async getItems({ currentPage, perPage, search }) {
      const { result, totalItems } = await servicesApi.selectService(
        currentPage,
        perPage,
        search
      );
      this.items = [...this.items, ...result];
      this.totalItems = totalItems;
    },
  },
};
</script>
